import { AbstractControl, ValidatorFn } from '@angular/forms';
import { FinnishSSN } from 'finnish-ssn';

export function finnishPersonNumberValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control.value) { return null; }
    const valid = FinnishSSN.validate(control.value.toUpperCase());
    return valid ? null : { invalidFinnishSSN: true };
  };
}
